module.exports = __webpack_public_path__ + "media/isabelle.71a31546.wav";